import { TokenDetails } from './token'
import { HierarchyDeepStructure } from 'src/typings/kenai/configuration/entity-hierarchy'
// import { defaultTokenValues } from './token'

type SelectedHierarchy = {
  hierarchyStructure: 'ALL' | string
  role: HierarchyDeepStructure['role']
}

class AccessManagerClass {
  idToken: any = undefined
  tokenDetails?: TokenDetails = undefined
  selectedHierarchy: SelectedHierarchy = {
    hierarchyStructure: 'ALL',
    role: 'DBUSER',
  }
  profileAccess: AccountProfile

  constructor() {
    this.selectedHierarchy = {
      hierarchyStructure: 'ALL',
      role: 'DBUSER',
    }
  }

  /// PRE-MIGRATION START
  /**
   * Returns the current OrganizationId from the tokenDetails
   *
   * - `tokenDetails.kna_OrganizationId`
   * - `this.tokenDetails['https://app.kenai.co.za/app_metadata'].amOrganizationId`
   */
  get organizationId() {
    return this.tokenDetails?.kna_OrganizationId ?? this.tokenDetails?.['https://app.kenai.co.za/app_metadata']?.amOrganizationId
  }

  /**
   * Return the bearer token for the current user
   *
   * - `Bearer ${this.idToken}`
   */
  get Authorization() {
    return `Bearer ${this.idToken}`
  }

  /// PRE-MIGRATION END

  clearAllStates = () => {
    this.idToken = undefined
    this.tokenDetails = undefined
    this.selectedHierarchy = {
      hierarchyStructure: 'ALL',
      role: 'DBUSER',
    }
  }

  setToken = (idToken, tokenDetails) => {
    this.idToken = idToken
    this.tokenDetails = tokenDetails
    this.setProfileAccess(tokenDetails)
    window.dispatchEvent(new CustomEvent('kenai:auth-token-set'))
  }

  setSelectedEntityHierarchy = (selectedHierarchy: HierarchyDeepStructure | 'ALL' = 'ALL') => {
    if (selectedHierarchy === 'ALL') {
      localStorage.setItem('cachedHierarchy', selectedHierarchy)
      this.selectedHierarchy = {
        hierarchyStructure: 'ALL',
        role: 'DBUSER',
      }
    } else {
      localStorage.setItem('cachedHierarchy', selectedHierarchy.hierarchyStructure)
      this.selectedHierarchy = {
        hierarchyStructure: selectedHierarchy.hierarchyStructure,
        role: selectedHierarchy.role,
      }
    }
  }

  hasAccess(key: Exclude<keyof AccountProfile, 'umName' | 'umEmail' | 'icUserHash'>) {
    return this.profileAccess[key]
  }
  private setProfileAccess(tokenDetails: TokenDetails) {
    const userMetadata = tokenDetails['https://app.kenai.co.za/user_metadata']
    const appMetadata = tokenDetails['https://app.kenai.co.za/app_metadata']

    if (userMetadata && appMetadata) {
      this.profileAccess = {
        umEmail: tokenDetails.email,
        ...userMetadata,
        ...appMetadata,
      }
    }

    if (tokenDetails.kna_Authorizations && tokenDetails.kna_DisplayName && tokenDetails.kna_OrganizationId) {
      const authData = JSON.parse(atob(AccessManager.tokenDetails.kna_Authorizations))
      this.profileAccess = {
        umEmail: tokenDetails.sub,
        umName: tokenDetails.kna_DisplayName,
        ...authData.authFlags,
      }
    }
  }
}

const AccessManager = new AccessManagerClass()

window.AccessManager = AccessManager

export default AccessManager
